import React from 'react';

// Selo "Exemplo" para itens do cardápio-base semeado (origem === 'exemplo').
// Renderiza nada quando o item é dado real da usuária.
export default function ExemploBadge({ origem, style }) {
  if (origem !== 'exemplo') return null;
  return (
    <span
      title="Item de exemplo do cardápio-base. Ajuste os dados para deixá-lo seu."
      style={{
        fontSize: 10,
        fontWeight: 700,
        color: '#8a6d1f',
        background: '#fff3d6',
        border: '1px solid #f0d68a',
        padding: '1px 7px',
        borderRadius: 8,
        marginLeft: 6,
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        ...style,
      }}
    >
      Exemplo
    </span>
  );
}
